import React from "react";
import { useImageSelector } from "../contexts/ImageSelectorContext";
import ImagePreview from "./ImagePreview";

const DragImageView = () => {
  const { images, addImage } = useImageSelector();

  const handleDrop = (event) => {
    event.preventDefault();
    const files = event.dataTransfer.files;
    if (files && files.length > 0) {
      Array.from(files).forEach((file) => addImage(URL.createObjectURL(file)));
    }
  };

  const handleFileChange = (event) => {
    const files = event.target.files;
    Array.from(files).forEach((file) => addImage(URL.createObjectURL(file)));
  };

  return (
    <div
      onDrop={handleDrop}
      onDragOver={(e) => e.preventDefault()}
      className="drag-image-view"
      style={{
        border: "2px dashed #ccc",
        padding: "20px",
        position: "relative",
        textAlign: "center",
        color: "#888",
        borderRadius: "8px",
        cursor: "pointer",
      }}
    >
      <p>Drag images here to attach</p>
      <input
        type="file"
        accept="image/*"
        multiple
        onChange={handleFileChange}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          opacity: 0,
          cursor: "pointer",
        }}
      />
      <div className="image-previews" style={{ marginTop: "10px" }}>
        {images.map((image, index) => (
          <ImagePreview key={index} image={image} index={index} />
        ))}
      </div>
    </div>
  );
};

export default DragImageView;
